import React, { useState } from 'react';
import { StyleSheet, TextInput } from 'react-native';
import { Button, Text } from '@rneui/themed';
import { useChannelQuery, useTagCreateMutation, useTagsQuery } from '@annunciate/query';
import { View } from '../elements';
import { useTheme } from '../../hooks';
export const TagCreateForm = ({ item, onCreate = () => { }, }) => {
    const { colors } = useTheme();
    const [newTagName, setTagName] = useState('');
    const { mutateAsync: create } = useTagCreateMutation();
    const { refetch } = useTagsQuery();
    const { data } = useChannelQuery();
    let recommendations = data?.channel?.settings?.tag?.recommendations || [];
    recommendations = recommendations.length > 0 ? recommendations : ['👍', '🎵', '📚', '📽️'];
    const createTag = async () => {
        if (!newTagName)
            return;
        const newTag = {
            name: newTagName,
            item: {
                entityId: item.id,
                entityType: item.__typename,
            },
        };
        try {
            await create(newTag);
            setTagName('');
            await refetch();
            onCreate();
        }
        catch (e) {
            console.error(e);
        }
    };
    return (React.createElement(View, { style: { padding: 15, paddingTop: 30 } },
        React.createElement(TextInput, { value: newTagName, onChangeText: setTagName, placeholder: "Tag Name", placeholderTextColor: colors.backgroundPrimary, onSubmitEditing: createTag, returnKeyLabel: "Create Tag", returnKeyType: "go", style: [
                styles.createInput,
                { backgroundColor: colors.grey0 }
            ] }),
        React.createElement(Button, { style: { marginTop: 10 }, disabled: !newTagName, onPress: createTag }, "Create"),
        React.createElement(View, { style: { paddingTop: 30 } },
            React.createElement(Text, { h2: true }, "Tags can be anything! A few ideas:"),
            React.createElement(View, { style: { paddingTop: 15, flexDirection: 'row', } }, recommendations.map((tag) => (React.createElement(Button, { style: styles.tag, onPress: () => setTagName(tag), title: tag })))))));
};
const styles = StyleSheet.create({
    createInput: {
        flexGrow: 1,
        borderRadius: 5,
        padding: 15,
    },
    tag: {
        marginRight: 10,
        padding: 10,
        borderRadius: 15,
    },
});
//# sourceMappingURL=TagCreateForm.js.map